import React, { useState, useContext } from 'react';
import { FaHome, FaProjectDiagram, FaBars, FaTimes, FaSignOutAlt } from 'react-icons/fa';
import { FaTimeline } from "react-icons/fa6";
import { ProjectContext } from './ProjectContext';

const Sidebar = ({ setCurrentView, currentView, setIsSidebarExpanded }) => {
  const { logout } = useContext(ProjectContext);
  const [isExpanded, setIsExpanded] = useState(true);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null); // Track hovered item

  const navItems = [
    { view: 'home', label: 'Home', icon: <FaHome /> },
    { view: 'read', label: 'Projects', icon: <FaProjectDiagram /> },
    { view: 'timeline', label: 'Timeline', icon: <FaTimeline /> },
  ];

  const toggleSidebar = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    setIsSidebarExpanded(newState);
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const handleLogout = () => {
    logout();
    setIsMobileOpen(false);
    setHoveredItem(null); // Clear hover on logout
  };

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-3 text-gray-900 bg-white rounded-lg shadow-lg hover:bg-neutral-100 transition-all duration-200"
        onClick={toggleMobileSidebar}
      >
        {isMobileOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed mt-20 pb-20 border-r-2 border-t-2 top-0 left-0 h-full bg-white transition-all duration-300 ease-in-out z-40
          ${isExpanded ? 'w-64' : 'w-16'}
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
      >
        <div className="flex flex-col h-full p-4">
          {/* Sidebar Header */}
          <div className="flex items-center justify-between mb-8">
            {isExpanded && (
              <h2 className="text-3xl font-light text-gray-700">Admin</h2>
            )}
            <button
              className={`p-2 text-gray-700 ${isExpanded ? 'hover:text-red-500' : 'hover:text-blue-400'} transition-colors`}
              onClick={toggleSidebar}
            >
              {isExpanded ? <FaTimes size={16} /> : <FaBars size={16} />}
            </button>
          </div>

          {/* Navigation Items */}
          <nav className="flex-1 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.view}
                className={`w-full flex items-center p-3 text-xl font-light rounded-lg transition-all duration-200
                  ${currentView === item.view
                    ? 'text-blue-400 bg-blue-50'
                    : hoveredItem === item.view
                    ? 'text-gray-900 bg-blue-50'
                    : 'text-gray-900 hover:bg-blue-50'
                  }
                  ${isExpanded ? 'justify-start' : 'justify-center'}
                `}
                onClick={() => {
                  setCurrentView(item.view);
                  setIsMobileOpen(false);
                  setHoveredItem(null);
                }}
                onMouseEnter={() => setHoveredItem(item.view)}
                onMouseLeave={() => setHoveredItem(null)}
                title={!isExpanded ? item.label : ''}
              >
                <span className={`${isExpanded ? 'mr-3' : ''}`}>{item.icon}</span>
                {isExpanded && <span>{item.label}</span>}
              </button>
            ))}
          </nav>

          {/* Logout Button */}
          <button
            className={`w-full flex items-center p-3 text-xl font-light rounded-lg transition-all duration-200
              ${hoveredItem === 'logout' ? 'text-red-600 bg-red-100' : 'text-red-600 hover:bg-red-100'}
              ${isExpanded ? 'justify-start' : 'justify-center'}
            `}
            onClick={handleLogout}
            onMouseEnter={() => setHoveredItem('logout')}
            onMouseLeave={() => {}}
            title={!isExpanded ? 'Logout' : ''}
          >
            <span className={`${isExpanded ? 'mr-3' : ''}`}>
              <FaSignOutAlt />
            </span>
            {isExpanded && <span>Logout</span>}
          </button>
        </div>
      </div>

      {/* Overlay for Mobile */}
      {isMobileOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/50 z-30"
          onClick={toggleMobileSidebar}
        />
      )}
    </>
  );
};

export default Sidebar;